export enum AlertsSort {
    CREATED_AT_ASC = 'createdAt',
    TRIP_CODE_ASC = 'trip.tripCode',
    VEHICLE_LICENSE_PLATE_ASC = 'vehicle.licensePlate',
    VEHICLE_NAME_ASC = 'vehicle.name',

    CREATED_AT_DESC = '-createdAt',
    TRIP_CODE_DESC = '-trip.tripCode',
    VEHICLE_LICENSE_PLATE_DESC = '-vehicle.licensePlate',
    VEHICLE_NAME_DESC = '-vehicle.name',
}
